import { useState } from "react";
import { Link } from "react-router-dom";
import PopupLightbox from "../components/PopupLightbox";

import imgCloseIcon from "../images/icon-close.png";

// import victorB from "../images/bio/alumni/victor-belo.jpg";
// import anon from "../images/bio/anonymous.png";
// import robL from "../images/bio/alumni/rob-lewis.jpg";
// import ericaP from "../images/bio/alumni/erica-pugh.jpg";
// import fadiaA from "../images/bio/alumni/fadia-azar.jpg";
// import rachelJ from "../images/bio/alumni/rachel-jepson.jpg";
import calebD from "../images/bio/alumni/calebD.jpg";
import davidM from "../images/bio/alumni/davidM.jpg";
import lauraW from "../images/bio/alumni/lauraW.jpg";
import michaelR from "../images/bio/alumni/mikeR.jpg";
import shelbiC from "../images/bio/alumni/shelbiC.jpg";
import stephG from "../images/bio/alumni/stephG.jpg";

const AlumniHighlights = () => {
  const [buttonPopup1, setButtonPopup1] = useState(false);
  const [buttonPopup2, setButtonPopup2] = useState(false);
  const [buttonPopup3, setButtonPopup3] = useState(false);
  const [buttonPopup4, setButtonPopup4] = useState(false);
  const [buttonPopup5, setButtonPopup5] = useState(false);
  const [buttonPopup6, setButtonPopup6] = useState(false);

  return (
    <div className="grid-container dark-bg">
      {/* <div class="grid-item grid-a">Emeriti</div>
      <div class="grid-item grid-b">b</div>
      <div class="grid-item grid-c">c</div> */}

      <div className="popup-wrapper">
        <div className="popup-col colC">
          <div className="popup-col-inner">
            <h2>Alumni Highlights</h2>
            <Link className="close-btn" to="/">
              <img src={imgCloseIcon} alt="close button" />
            </Link>

            <ul className="circle-container">
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${shelbiC})` }}
                  onClick={() => setButtonPopup3(true)}
                >
                  <span>Shelbi Clinger</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${calebD})` }}
                  onClick={() => setButtonPopup6(true)}
                >
                  <span>Caleb Debenham</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${stephG})` }}
                  onClick={() => setButtonPopup1(true)}
                >
                  <span>Stephanie Greenland</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${davidM})` }}
                  onClick={() => setButtonPopup4(true)}
                >
                  <span>David Morrell</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${michaelR})` }}
                  onClick={() => setButtonPopup2(true)}
                >
                  <span>Michael Ryburg</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${lauraW})` }}
                  onClick={() => setButtonPopup5(true)}
                >
                  <span>Laura Walter</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <PopupLightbox trigger={buttonPopup1} setTrigger={setButtonPopup1} columnPosition="colB">
        <h3>Stephanie Greenland</h3>
        <p>
          Stephanie Greenland’s (BS 2019) interest in accounting started in high school through finance classes and a
          job as a tax preparer at Jackson Hewitt. She earned her accounting degree from BYU and completed her MAcc at
          Utah State University while raising two young children. During her final semester, she interned at Jones
          Simkins and later accepted a full-time position there. After relocating to Idaho, she transitioned to a remote
          role with the firm. Now focused on her family and preparing for the CPA exam (two tests down), Greenland
          reflects fondly on the SOA community and the valuable connections she made. Outside of work, she enjoys
          outdoor activities, sports, and spending time with her four kids.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup2} setTrigger={setButtonPopup2} columnPosition="colB">
        <h3>Michael Ryburg</h3>
        <p>
          Michael Ryburg (MAcc 2019) always knew he would end up in business, but it wasn’t until he took an
          introductory accounting class that he realized accounting was the right path for him. After earning his MAcc,
          Ryburg began his career auditing at KPMG before transitioning into a finance role at Home Depot, where he now
          serves as global FP&A manager. Though no longer in a traditional accounting position, he values how essential
          those skills remain in understanding and driving business performance. Since graduating from the SOA, Ryburg
          and his wife have made their home in Georgia, where they enjoy exploring the mountains, cheering on the
          Braves, and chasing after their energetic toddler.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup3} setTrigger={setButtonPopup3} columnPosition="colB">
        <h3>Shelbi Clinger</h3>
        <p>
          After beginning her studies in elementary education at BYU, Shelbi Clinger (BS 2020) made a bold pivot to
          business and discovered an unexpected love for accounting. Following graduation, she joined Deloitte’s risk
          and financial advisory team in Seattle and earned her CPA license. However, the call to teach never left.
          Clinger returned to education as a clinical lecturer at Idaho State University, where she now helps future
          educators learn to teach subjects like business, nursing, and automotive trades. She has also contributed to
          curriculum development, recruitment, and educational outreach. Outside of work, she enjoys traveling, baking,
          reading, and spending time with her husband and daughter.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup4} setTrigger={setButtonPopup4} columnPosition="colB">
        <h3>David Morrell</h3>
        <p>
          Having lived a rich and meaningful life, David Morrell (BS 1960) has found that true success comes from living
          with obedience, faithfulness, love, and a spirit of service. After serving a mission in Denmark for The Church
          of Jesus Christ of Latter-day Saints and serving in the Korean War, David pursued his education at Weber State
          and BYU before becoming an accountant and business administrator for the Box Elder School District, where he
          spent his entire career. Married to Shirley Klingler, he is the proud father of seven children and grandfather
          to 26 grandchildren. Now retired, Morrell enjoys cheering on BYU athletics, doing family history, and
          attending the temple weekly. His advice is simple: Stay rooted in the gospel, and let faith and family guide
          every decision.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup5} setTrigger={setButtonPopup5} columnPosition="colB">
        <h3>Laura Walter</h3>
        <p>
          Growing up as a competitive figure skater, Laura Walter (MAcc 2015) once thought her future was on the ice.
          However, encouragement from both her bishop and father eventually led her to BYU Marriott’s School of
          Accountancy. Her time at the SOA helped her build confidence and recognize her potential to reach for more
          than she had previously dreamed. After graduation, she joined EY’s global mobility team before founding Crypto
          Tax Girl, a tax firm that has grown into a 16-member team specializing in cryptocurrency. Today, she balances
          entrepreneurship with family life, splitting time between Utah and Tokyo with her husband and two children as
          they explore the world together.
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup6} setTrigger={setButtonPopup6} columnPosition="colB">
        <h3>Caleb Debenham</h3>
        <p>
          BYU’s educational reputation is what drew Caleb Debenham (MAcc 2013) to its campus and ultimately to the SOA,
          where he quickly came to appreciate how accounting unlocks a deeper understanding of what’s really happening
          inside a business. That foundation has fueled a dynamic career across strategy, corporate development, finance
          operations, and now, new product development. As a senior director of strategy and innovation at Cencora, he
          helps create solutions that advance healthcare. Debenham lives by the principle of trying new things, a
          mindset reflected in his career journey and his goal of starting his own business. He encourages students to
          do the same and maintain an open mind as they explore their own career paths.
        </p>
      </PopupLightbox>
    </div>
  );
};

export default AlumniHighlights;
